import { AssociationsSubModel} from "sharedFeatures/sharedModels/xero/associationsSubModel";

export class AssociationsModel {

    [key: string]: AssociationsSubModel;

    constructor() { }

}